import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GridApi } from "ag-grid-community";

import { GrantsSummaryService } from "src/app/services/grants/grants-summary.service";
import { UserService } from "src/app/services/user.service";

import { Subject } from "rxjs";
import { GM_RECONCILIATION, Model, ScreenResponseModel } from 'src/app/models/common';
import { MessageBoxComponent } from "src/app/common/message-box/message-box.component";
import { DeleteBoxComponent } from "src/app/common/delete-box/delete-box.component";
import { GrantsBudgetViewModalComponent } from './grants-budget-view-modal/grants-budget-view-modal.component';
import { GrantsBudgetAllocateComponent } from './grants-budget-allocate/grants-budget-allocate.component';
import { GrantsBudgetViewBudgetRequestComponent } from './grants-budget-view-budget-request/grants-budget-view-budget-request.component';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { stateOptionsConstant, deliveryFormatOptionsConstant, countryOptionsConstant, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GrantsBudgetRecordExpenditureComponent } from "../grants-reconciliation/grants-budget-record-expenditure/grants-budget-record-expenditure.component";
import { HeadService } from "src/app/services/common/headservice";
import { IstDataShareService } from "src/app/services/ist/ist-datashare.service";
import { GrantsDatashareService } from "src/app/services/grants/grants-datashare.service";
import { AdministrationSummaryService } from "src/app/services/administration/administration-summary.service";

@Component({
  selector: 'app-grants-budget',
  templateUrl: './grants-budget.component.html',
  styleUrls: ['./grants-budget.component.scss']
})
export class GrantsBudgetComponent implements OnInit {
  collapesedOrNot: boolean;
  userForm: UntypedFormGroup;

  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  appid: string;
  userdetails: any;
  userType: string;
  tempoperations;
  budgetsum: GM_RECONCILIATION;
  totalfee: number;
  allocationamount: number;
  requestamount: number;
  expamount: number;
  balanceamount: number;
  grantcurrencycode: any = "";
  granttype: number;
  permission: string;
  permissionCode: string;
  screenPermission: string;
  grantapp: any;
  screencode : any;
  staticformFields: any;

  budgetTypeOptions = [];

  budgetSubTypeOptions = [];

  budgetStatusOptions = [
    { value: -1, label: 'All' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'Submitted' },
    { value: 3, label: 'Withdrawn' },
    { value: 4, label: 'Approved' },
    { value: 6, label: 'Rejected' },
    { value: 11, label: 'Allocated' },
    { value: 12, label: 'Closed' }
  ];

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private summaryservice: AdministrationSummaryService,
    private modalService: NgbModal,
    private userService: UserService,
    private commonService: CommonService,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService
  ) { 
    this.screencode = route.snapshot.params['code'];
  }
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe(summary => {
        this.staticformFields = summary["Data"]; 
        this.columnDefs = [
          {
            "headerName": this.staticformFields?.BUGET_TYPE_ID.LABEL_NAME,
            "field": "BUGET_TYPE_ID_Str",
            "sortable": true,
          },
          {
            "headerName": this.staticformFields?.BUDGET_SUB_TYPE_ID.LABEL_NAME,
            "field": "BUDGET_SUB_TYPE_ID_Str",
            "sortable": true,
          },
          {
            "headerName": this.staticformFields?.TOTAL_FEE.LABEL_NAME,
            "field": "TOTAL_FEE_Str",
            "sortable": true,
          },
          {
            "headerName": this.staticformFields?.REQUESTED_AMOUNT.LABEL_NAME,
            "field": "REQUESTED_AMOUNT_Str",
            "sortable": true,
          },
          {
            "headerName": this.staticformFields?.ALLOCATION_AMOUNT.LABEL_NAME,
            "field": "ALLOCATION_AMOUNT_Str",
            "sortable": true,
          },
          {
            "headerName": "Status",
            "field": "StatuStr",
            "sortable": true,
          }
        ];
      });
  }


  ngOnInit() {
    this.grantapp = this.commonService.getGrantsApp();
    this.appid = this.grantapp?.ID;

    this.getStaticFiledsData('SCR-026');
    this.NavigateToGenInfo()
    this.userType = this.userService.getUserType();
    this.granttype = this.grantapp.GRANT_TYPE;
    this.getFundCategoryList();
    this.getFundSubCategoryList("null");

    this.userForm = new UntypedFormGroup({
      BUGET_TYPE_ID: new UntypedFormControl(""),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl(""),

      BUDGET_STATUS: new UntypedFormControl("")
    });
    this.tempoperations = [];
    this.columnDefs = [
      {
        "headerName": "Budget Type",
        "field": "BUGET_TYPE_ID_Str",
        "sortable": true,
      },
      {
        "headerName": "Budget Sub Type",
        "field": "BUDGET_SUB_TYPE_ID_Str",
        "sortable": true,
      },
      {
        "headerName": "Total Fees",
        "field": "TOTAL_FEE_Str",
        "sortable": true,
      },
      {
        "headerName": "Requested Amount",
        "field": "REQUESTED_AMOUNT_Str",
        "sortable": true,
      },
      {
        "headerName": "Allocated Amount",
        "field": "ALLOCATION_AMOUNT_Str",
        "sortable": true,
      },
      {
        "headerName": "Status",
        "field": "StatuStr",
        "sortable": true,
      }
    ];
    this.advanceSearch = {
      "fields": [
        {
          "label": "Type",
          "field": "simple",
          "type": "dropdown"
        },
        {
          "label": "Sub Type",
          "field": "program_type",
          "type": "dropdown"
        },
        {
          "label": "Date From",
          "field": "date_from",
          "type": "date"
        },
        {
          "label": "Date To",
          "field": "date_to",
          "type": "date"
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown"
        }
      ],
      "filters": []
    };

    this.permissionCode = "GC05"; //Work flow security code

    this.permission = this.commonService.getPagePermission(this.permissionCode).toLowerCase();

    this.getCurrencySym(this.appid);

    this.setSummary();
    this.setBudgetSum();

  }

  setOperations(RawData: any): any {

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (this.userType === "I" && element.StatuStr === "Submitted") {
        let tempoperations = [
          {
            "name": "View",
            "id": "view"
          },          
          {
            "name": "Approve",
            "id": "approve"
          },
          {
            "name": "Reject",
            "id": "reject"
          }
        ]
        element["Operations"] = this.setDef(tempoperations);
      }

      if (this.userType === "I" && element.StatuStr === "Approved") {
        let tempoperations = [          
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Allocate",
            "id": "allocate"
          }
        ]
        element["Operations"] = this.setDef(tempoperations);
      }

      if (this.userType === "I" && (element.StatuStr === "Allocated" || element.StatuStr === "Rejected")) {
        let tempoperations = [ 
          {
            "name": "View",
            "id": "view"
          }
        ]    

        element["Operations"] = this.setDef(tempoperations);
      }     

      if(this.grantapp.GRANT_TYPE == 1){
        if(element.StatuStr == "Allocated"){
          let tempoperations = [ 
            {
              "name": "View",
              "id": "view"
            }
          ] 
  
          element["Operations"] = this.setDef(tempoperations);
        } 
      } else{
        if(element.StatuStr == "Allocated" 
        && element.EXPENDITURE_AMOUNT != null &&  element.EXPENDITURE_AMOUNT != undefined && element.EXPENDITURE_AMOUNT != ''){
          let tempoperations = [ 
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ] 
  
          element["Operations"] = this.setDef(tempoperations);
        } 
      }

      if (this.userType === "E" && element.StatuStr === "Draft" && (this.permission == "new" || this.permission == "edit")) {
        let tempoperations = [        
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Delete",
            "id": "delete"
          },
          {
            "name": "Edit",
            "id": "edit"
          }
        ];
        element["Operations"] = this.setDef(tempoperations);
      }

      if (this.userType === "E" && (element.StatuStr === "Submitted"  || element.StatuStr === "Approved")) {
        let tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];
        element["Operations"] = this.setDef(tempoperations);

      }

      if (this.userType === "E" && element.StatuStr === "Withdrawn") {
        let tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        element["Operations"] = this.setDef(tempoperations);

      }      

      if (this.userType === "E" && element.StatuStr === "Allocated") {
        let tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Edit",
            "id": "markExpenditure"
          }
        ];
        element["Operations"] = this.setDef(tempoperations);

      }

      if(element.StatuStr === "Closed" || element.StatuStr === "Rejected" || element.StatuStr === "Withdrawn"){

         let tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        element["Operations"] = this.setDef(tempoperations);
      }
      
       if(this.permission == 'view'){
         let tempoperations = [
           {
             "name": "View",
             "id": "view"
           }
         ];
         element["Operations"] = this.setDef(tempoperations);
       }

    });


    return RawData;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  AdvanceSearch() {
    var formData = this.userForm.value;
    var BUGET_TYPE_ID = "";
    var BUDGET_SUB_TYPE_ID = "";
    var BUDGET_STATUS = -1;

    if (formData.BUGET_TYPE_ID != null && formData.BUGET_TYPE_ID != "" && formData.BUGET_TYPE_ID != undefined) {
      BUGET_TYPE_ID = formData.BUGET_TYPE_ID;
    }
    if (formData.BUDGET_SUB_TYPE_ID != null && formData.BUDGET_SUB_TYPE_ID != "" && formData.BUDGET_SUB_TYPE_ID != undefined) {
      BUDGET_SUB_TYPE_ID = formData.BUDGET_SUB_TYPE_ID;
    }
    if (formData.BUDGET_STATUS != null && formData.BUDGET_STATUS != "" && formData.BUDGET_STATUS != undefined) {
      BUDGET_STATUS = formData.BUDGET_STATUS;
    }

    this.userType = this.userService.getUserType();

    this.summaryService.getBudgetsAdvanceSummary("0", this.userType, this.appid, BUGET_TYPE_ID, BUDGET_SUB_TYPE_ID, BUDGET_STATUS).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });

  }

  getFundCategoryList() {
    this.summaryService.getBudgetTypeList(this.appid).subscribe((result) => {
      if (result != null) {
        this.budgetTypeOptions = result;
        this.budgetTypeOptions = [{ label: "All", value: null, checked: true }].concat(this.budgetTypeOptions);
      }
    });
  }

  getFundSubCategoryList(typeid: any) {
    let model = new ScreenResponseModel();
    model.Id = typeid;
    model.AppId = this.appid;
    model.RowId = null;
    this.summaryService.getBudgetSubTypeList(model).subscribe((result) => {
      if (result != null) {
        this.budgetSubTypeOptions = result;
        this.budgetSubTypeOptions = [{ label: "All", value: null, checked: true }].concat(this.budgetSubTypeOptions);
      }
    });
  }

  getCurrencySym(appId: string){
    this.summaryService.getCurrency(appId).subscribe((result)=>{
      if(result.Status == 0 && result.Data != null){
        this.grantcurrencycode = result.Data;
      }
      else{
         this.getLatestSymbol();
      }
    });
  }
  getLatestSymbol()
  {
    if (this.granttype == 1)
    {
      this.userService.getGrantCMECurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 2)
    {
      this.userService.getGrantSponsorCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 3)
    {
      this.userService.getGrantCharitableCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
  }

    // if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
    //   this.grantcurrencycode = "$";

  

  getSelectedValue(value: any): void {
    this.getFundSubCategoryList(value);
  }

  SearchClear() {
    this.userForm = new UntypedFormGroup({
      BUGET_TYPE_ID: new UntypedFormControl(""),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl(""),
      BUDGET_STATUS: new UntypedFormControl(-1)
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows()
      ? this.gridApi.getSelectedRows()[0]
      : null;
  }

  onRowDoubleClicked(event) {
    const modelRef = this.modalService.open(GrantsBudgetViewBudgetRequestComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: "modal-lg modal-full-height modal-right",
      animation: true
    });
    modelRef.componentInstance.Content = {
      heading: "View",
      content: { id: this.selectedRow["ID"], appid: this.appid }
    }

  }

  add() {
    let modalRef = this.modalService.open(GrantsBudgetViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: "Add",
      content: { id: "0", appid: this.appid }

    }
    modalRef.result.then(result => {
      this.setSummary();
    })
  }

  edit(RecordData: any) {
    if (parseInt(RecordData['STATUS']) == 1 || parseInt(RecordData['STATUS']) == 11 || RecordData['STATUS'] == null) {
      let modalRef = this['self'].modalService.open(GrantsBudgetViewModalComponent, {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        windowClass: 'modal-vlg right modal-right',
        animated: true,
      });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
        content: { id: RecordData['ID'], appid: this.appid }
      }
      modalRef.result.then(result => {
        this['self'].setSummary();
      })
    }
    else {
      this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        data: { heading: 'Allocate', content: { heading: '', description: 'Only draft status Record can be Modified' } }
      });
    }

  }

  allocate(RecordData: any) {

    if (parseInt(RecordData['STATUS']) == 4) {
      let modalRef = this["self"].modalService.open(
        GrantsBudgetAllocateComponent,
        {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          windowClass: 'modal-vlg right modal-right',
          animated: true,
        });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
        content: { id: RecordData['ID'], appid: this.appid }
      }
      modalRef.result.then(result => {
        this['self'].setSummary();
        this['self'].setBudgetSum();        
      });
    }
    else {
      this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        data: { heading: 'Allocate', content: { heading: '', description: 'Only Approved status record can be Allocated.' } }
      });
    }
  }

  submit(RecordData: any) {
    if (parseInt(RecordData['STATUS']) == 1) {
      this['self'].summaryService.statusupdate("api/gmbudget/statusupdate/", RecordData['ID'], 2).subscribe(result => {
        this['self'].commonService.SuccessBanner("Record submitted successfully");
        this['self'].setSummary();
        this['self'].setBudgetSum();
      })
    }
    else {
      this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        data: { heading: 'Submit', content: { heading: '', description: 'Only draft status Record can be Submitted' } }
      });
    }
  }

  delete(RecordData: any) {
    if (parseInt(RecordData['STATUS']) == 1 || RecordData['STATUS'] == null) {
      let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content = { heading: 'Delete', custommessage: 'Are you sure you want to delete the Budget Requirement?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.deleteRecord("api/gmbudget/delete/", RecordData['ID'], RecordData['APPLICATION_ID']).subscribe(result => {
            if (result.Status == 0) {
              this['self'].commonService.SuccessBanner('Budget request has been deleted successfully');
              this['self'].setSummary();
              this['self'].modalRef.close();
            }
          })
        }

      })
    }
    else {
      this.commonService.ErrorBanner("The submitted budget requirement cannot be deleted");
    }
  }

  view(RecordData: any) {
      let modalRef = this['self'].modalService.open(GrantsBudgetViewBudgetRequestComponent, {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        windowClass: 'modal-vlg right modal-right',
        animated: true,
      });
      modalRef.componentInstance.Content = {
        heading: 'View',
        content: { id: RecordData['ID'], appid: this.appid, record: RecordData }
      }
      modalRef.result.then(result => {
        this['self'].setSummary();
      });   
  }

  setSummary() {
    let model = new Model();
    model.Text = "0";
    model.Type = this.userType;
    model.AppId = this.appid;

    this.SearchClear();
    this.userType = this.userService.getUserType();
    this.summaryService.getBudgetsSummary(model).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setBudgetSum() {
    this.summaryService.getBudgetSum(this.appid, "S").subscribe(summary => {
      this.budgetsum = summary
      if (this.budgetsum != null) {
        this.totalfee = this.budgetsum.TOTAL_FEE;
        this.requestamount = this.budgetsum.REQUESTED_AMOUNT;
        this.allocationamount = this.budgetsum.ALLOCATION_AMOUNT;
        this.expamount = this.budgetsum.EXPENDITURE_AMOUNT;
        this.balanceamount = this.budgetsum.BALANCE;
      }
    });
  }

  approve() {
    var selectedid = this['self'].selectedRow['STATUS'];
    if (selectedid == null || selectedid == undefined)
      selectedid = 1;
    if (parseInt(selectedid) == 2 || parseInt(selectedid) == 1) {
      this['self'].summaryService.statusupdate("api/gmbudget/statusupdate/", this['self'].selectedRow['ID'], 4).subscribe(result => {
        if (result.Status == 0) {
          this['self'].commonService.SuccessBanner("Request has been Approved");
          this['self'].setSummary();
        }
      });
    }
    else {
      this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        data: { heading: 'Active', content: { heading: '', description: 'Draft or Submitted status record only can be Approved.' } }
      });
    }
  }

  reject() {
    var selectedid = this['self'].selectedRow['STATUS'];
    if (selectedid == null || selectedid == undefined)
      selectedid = 1;
    if (parseInt(selectedid) == 2 || parseInt(selectedid) == 1) {
      this['self'].summaryService.statusupdate("api/gmbudget/statusupdate/", this['self'].selectedRow['ID'], 6).subscribe(result => {
     
        this['self'].commonService.SuccessBanner("Request has been Rejected");        
        this['self'].setSummary();
        this['self'].setBudgetSum();
      });      
    }
    else {
      this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
        data: { heading: 'Active', content: { heading: '', description: 'Draft or Submitted status record only can be Rejected.' } }
      });
    }

  }

  withdraw() {
    this['self'].summaryService.statusupdate("api/gmbudget/statusupdate/", this['self'].selectedRow['ID'], 3).subscribe(result => {
      this['self'].commonService.SuccessBanner("The budget request has been withdrawn successfully");
      this['self'].setSummary();
      this['self'].setBudgetSum();
    });
  }

  close() {
    this['self'].summaryService.statusupdate("api/gmbudget/statusupdate/", this['self'].selectedRow['ID'], 12).subscribe(result => {
      this['self'].commonService.SuccessBanner("Budget request closed successfully");
      this['self'].setSummary();      
    });
  }
  
  markExpenditure() {
    let modalRef = this["self"].modalService.open(
      GrantsBudgetViewBudgetRequestComponent,
      {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        windowClass: 'modal-vlg right modal-right',
        animated: true,
      });
      modalRef.componentInstance.Content = {
        heading: 'View',
        content: { id: this['self'].selectedRow['ID'], appid: this.appid, screen: "Budget", record: this['self'].selectedRow, budgetId: this['self'].selectedRow['BUGET_TYPE_ID']}
      }
      modalRef.result.then(result => {
        this['self'].setSummary();
        this['self'].setBudgetSum();
      });
  }

  NavigateToGenInfo() {
    const menu = this.commonService.getModuleMenu();
   this.commonService.getScreenStaticFields('SCR-026',this.appid)
    .subscribe(summary => {
      let staticformFields : any = summary["Data"]; 
    });
    this.summaryservice.getScreenRepositorySummary("0",this.screencode).subscribe(summary => {
      let rowData:any  = this.setOperations(summary);
    });


    if (menu != null) {
      switch (menu.module) {
        case "GRANTSCME":
            this.appid = this.commonService.appId;
            if (this.appid == null || this.appid == undefined || this.appid == "") {
              const modalRefAuth1 = this.modalService.open(MessageBoxComponent, {});
              modalRefAuth1.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Budget', operation: { hasConfirm: false } } };
              modalRefAuth1.result.then((result) => {
                this.router.navigate(['/home/grants/my-applications/application-ext/:' +0 + '/geninfocme'],
                  { skipLocationChange: true, queryParams: { id:0, app_ext: true, module: "grants",submodule:menu.module, screen_type: "my-applications" } })
              });
              return false;
            }

          break;
        case "GRANTSSPONSORSHIP":
            this.appid = this.commonService.appId;
            if (this.appid == null || this.appid == undefined || this.appid == "") {
              const modalRefAuth2 = this.modalService.open(MessageBoxComponent, {});
              modalRefAuth2.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Budget', operation: { hasConfirm: false } } };
              modalRefAuth2.result.then((result) => {
                this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/genInformsponsorship'],
                  { skipLocationChange: true, queryParams: { id:0, app_ext: true, module: "grants",submodule:menu.module, screen_type: "my-applications" } })
              });
              return false;
            }
          break;
        case "GRANTSCHARITABLE":
            this.appid = this.commonService.appId;
            if (this.appid == null || this.appid == undefined || this.appid == "") {
              const modalRefAuth3 = this.modalService.open(MessageBoxComponent, {});
              modalRefAuth3.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Budget', operation: { hasConfirm: false } } };
              modalRefAuth3.result.then((result) => {
                this.router.navigate(['/home/grants/my-applications/application-ext/:' +0 + '/genInformcharitable'],
                  { skipLocationChange: true, queryParams: { id: 0, app_ext: true, module: "grants",submodule:menu.module, screen_type: "my-applications" } })
              });
              return false;
            }
          break;
        default:
          break;
      }
    }

  }

}
